<div class="bc-email-box bc-panel" *ngIf="lastEmail && emailThread">
  <div class="column-flex-container email-panel bc-layout-wrapper {{workItemThemeClass}}">

    <app-visitor-history class="column-flex-fix" *ngIf="!isExpandedMode() && emailThread && lastEmail && !isTransferPanelActive" [emailThreadId]="emailThread.id" [emailId]="lastEmail.id"></app-visitor-history>

    <div class="column-flex-grow bc-panel-maxh ignore-overflow override-flex">
      <div class="bc-work-widget-body column-flex-container" *ngIf="!isTransferPanelActive">
        <app-email-viewer class="bc-content-inner column-flex-grow" [email]="lastEmail"></app-email-viewer>

        <div *ngIf="isEmailThreadActive() && isFocused()" class="send-message-control column-flex-fix">
          <div class="email-panel-footer row no-margin work-widget-panel-footer">
            <app-alert-box [editorMessages]="editorMessages.messages" (closeHandler)="clearEditorMessage()"></app-alert-box>

            <div class="email-panel-footer-controls">
              <app-loading *ngIf="!areWrapupsLoaded && isFooterModeActive(footerModes.WRAPUP)"></app-loading>

              <app-wrap-up-panel *ngIf="areWrapupsLoaded && isFooterModeActive(footerModes.WRAPUP)"
                               [workItemId]="workItemId"
                               [isEnded]="!isEmailThreadActive()"
                               [isClosed]="!isEmailThreadActive()"
                               [type]="workItemType"
                               [rawWrapups]="wrapups"
                               (togglePanel)="toggleWrapupPanel()"></app-wrap-up-panel>

              <app-email-outgoing-header
                *ngIf="isFooterModeActive(footerModes.HEADER)"
                [model]="compose"
                (onSave)="onHeaderSave($event)"
                (onCancel)="onHeaderCancel($event)"
                (onFromAddressChange)="changeSenderEmailAccount($event)"></app-email-outgoing-header>

              <app-email-control-panel
                *ngIf="isFooterModeActive(footerModes.CONTROL_PANEL)"
                [showDiscussionButton]="isExpandedMode() && canStartDiscussion"
                [isDiscussionButtonDisabled]="isDiscussionsLaneVisible"
                [hasWrapUps]="hasWrapUps()"
                [attr.data-automation-id]="'bc-email-control-panel'"
                (reply)="pressReply()"
                (replyAll)="pressReplyAll()"
                (forward)="pressForward()"
                (discuss)="pressDiscuss()"
                (close)="closeEmailThreadOrShowConfirmation()"
                (transfer)="toggleTransferPanel()"
                (wrapUp)="toggleWrapupPanel()"></app-email-control-panel>

              <div class="js-outgoing-email" [hidden]="!isFooterModeActive(footerModes.EDITOR)">
                <a *ngIf="!isExpandedMode() && !isMoreActionsVisible"
                   (click)="toggleCannedMessagePanel()"
                   class="btn btn-borderless btn-cm"
                   data-automation-id="email-canned-message-btn">
                  <svg-icon icon="can-outline"></svg-icon>
                </a>

                <app-editor [hidden]="!isExpandedMode() && isMoreActionsVisible"
                            [ngClass]="{ 'has-attachment': !attachments?.isEmpty() }"
                            [editorInitSetting]="editorInitSetting"
                            (editorSetupDone)="onEditorSetupDone($event)"
                            [workItemId]="workItemId"
                            [commandList]="editorCommandList"
                            (onCommandSelected)="executeCommand($event)"
                            [editorMessages]="editorMessages"
                            [cannedMessageRequest]="cannedMessageRequest"
                            [(editorContentModel)]="compose.message"
                            [showQuoteButton]="!isQuotedMessageAdded"
                            (quoteButtonClick)="addQuotedContent()"
                ></app-editor>

                <app-email-attachments
                  *ngIf="isExpandedMode() && !attachments?.isEmpty()"
                  class="email-attachment-aligned-list"
                  [attachments]="attachments?.files"
                  (deleteAction)="attachments?.deleteAttachment($event)"></app-email-attachments>

                <div class="bc-footer-buttons clearfix" *ngIf="isExpandedMode() && isFooterModeActive(footerModes.EDITOR)">
                  <div class="bc-footer-buttons-left">
                    <button (click)="sendAndCloseEmailOrShowConfirmation()"
                            [disabled]="isSendingInProgress() || !hasValidEmailHeader()"
                            class="btn bc-footer-button js-send-and-close-email-button btn-dark"
                            title="{{sendButtonErrorMessage | translate}}"
                            [attr.data-automation-id]="'bc-email-box-send-and-close-button'">
                      <span>{{ 'bcEmailBox.sendAndCloseButton' | translate }}</span>
                    </button>
                    <button ngfSelect
                         [(file)]="selectedFile"
                         (fileChange)="attachments?.uploadFiles(selectedFile)"
                         class="btn bc-footer-button btn-light">
                      <span>Attachments</span>
                    </button>
                    <button (click)="sendEmailMessageClick()"
                            [disabled]="isSendingInProgress() || !hasValidEmailHeader()"
                            class="btn btn-light bc-footer-button js-send-email-button"
                            title="{{sendButtonErrorMessage | translate}}"
                            [attr.data-automation-id]="'bc-send-email-button'">
                      <span>{{ 'bcEmailBox.sendButton' | translate }}</span>
                    </button>
                    <button (click)="openOutgoingHeaderPanel()"
                            [disabled]="isSendingInProgress()"
                            class="btn btn-light bc-footer-button js-open-outgoing-header-button"
                            [attr.data-automation-id]="'bc-open-outgoing-header-button'">
                      <span>{{ 'bcEmailBox.openOutgoingHeaderButton' | translate }}</span>
                    </button>
                  </div>

                  <div class="bc-footer-buttons-right pull-right clearfix">
                    <button (click)="openDiscussions()" *ngIf="canStartDiscussion" [disabled]="isDiscussionsLaneVisible" class="btn btn-light bc-footer-button js-discuss-button">
                      <span>{{ 'bcEmailBox.discussionsButton' | translate }}</span>
                    </button>
                    <button (click)="onReplyCancel()"
                            class="btn btn-light bc-footer-button"
                            [attr.data-automation-id]="'bc-email-box-cancel-button'">
                      <span>{{ 'bcEmailBox.cancelButton' | translate }}</span>
                    </button>
                    <button *ngIf="hasWrapUps()" (click)="toggleWrapupPanel()" class="btn btn-light bc-footer-button js-wrap-up-button" id="email-wrap-up-button">
                      <span>{{ 'bcEmailBox.wrapUpButton' | translate }}</span>
                    </button>
                    <button (click)="closeEmailThreadOrShowConfirmation()"
                            class="btn btn-light bc-footer-button js-close-email-thread-button"
                            [attr.data-automation-id]="'bc-email-box-close-thread'">
                      <span>{{ 'bcEmailBox.closeThreadButton' | translate }}</span>
                    </button>
                  </div>
                </div>

                <div class="more-actions" *ngIf="!isExpandedMode()" [ngClass]="{ 'open': isMoreActionsVisible }">
                  <div class="email-footer-icon-container" *ngIf="!isMoreActionsVisible">
                    <app-email-attachments
                      *ngIf="!attachments?.isEmpty()"
                      [attachments]="attachments?.files"
                      (deleteAction)="attachments?.deleteAttachment($event)"></app-email-attachments>
                    <div ngfSelect
                         [(file)]="selectedFile"
                         (fileChange)="attachments?.uploadFiles(selectedFile)"
                         class="btn bc-footer-button bc-attachment-button collapsed-email-footer-icon"
                         [attr.data-automation-id]="'bc-email-attachment-button'">
                      <svg-icon icon="attachment"></svg-icon>
                    </div>

                    <svg-icon icon="ellipsis"
                              (click)="toggleMoreActions()"
                              class="collapsed-email-footer-icon more-actions-icon"
                              [attr.data-automation-id]="'bc-email-box-more-actions-icon'"></svg-icon>
                  </div>

                  <app-email-more-actions
                    *ngIf="isMoreActionsVisible"
                    [hasWrapUps]="hasWrapUps()"
                    (sendAndClose)="sendAndCloseEmailOrShowConfirmation()"
                    (send)="sendEmailMessageClick()"
                    (subjectAndMore)="openOutgoingHeaderPanel()"
                    (transfer)="toggleTransferPanel()"
                    (cancelEmail)="onReplyCancel()"
                    (closeEmail)="closeEmailThreadOrShowConfirmation()"
                    (togglePanel)="toggleMoreActions()"
                    (wrapUp)="toggleWrapupPanel()"
                  ></app-email-more-actions>
                </div>
              </div>
            </div>

            <app-auto-save [model]="footer" [storageKey]="'email-footer-' + emailThread.id"></app-auto-save>
            <app-auto-save [model]="outgoingHeaderCancelFooter" [storageKey]="'email-cancel-footer-' + emailThread.id"></app-auto-save>
          </div>
        </div>
        <app-auto-save [model]="compose" [storageKey]="'email-' + emailThread.id" *ngIf="isEmailThreadActive()"></app-auto-save>
      </div>

      <div class="bc-content-inner bc-layout-wrapper" *ngIf="isTransferPanelActive && isEmailThreadActive()">
        <app-transfer-panel (backButtonAction)="toggleTransferPanel()"
                           [workItemId]="workItemId"
                           [workItemType]="workItemType"></app-transfer-panel>
      </div>
    </div>

    <app-confirmation-modal
      #sendAndCloseConfirmationModal
      *ngIf="!isConfirmationModalDisabled() && sendAndCloseConfirmationVisible"
      (cancel)="hideSendAndCloseConfirmation()"
      (confirm)="sendAndClose()"
      (secondaryAction)="sendAndCloseAndDontShowModal()"
      [config]="sendAndCloseConfirmationBoxConfig"></app-confirmation-modal>

    <app-confirmation-modal
      #closeConfirmationModal
      *ngIf="!isConfirmationModalDisabled() && closeConfirmationVisible"
      (cancel)="hideCloseEmailConfirmation()"
      (confirm)="closeEmailThread()"
      (secondaryAction)="closeEmailThreadAndDontShowModal()"
      [config]="closeConfirmationBoxConfig"></app-confirmation-modal>
  </div>
</div>
<div class="inactive-email-panel-footer" *ngIf="!isFocused()">
  <app-inactive-widget-footer [text]="compose.message"></app-inactive-widget-footer>
</div>
